import type { ChatMessage } from "../chat/types";

export type Step = {
  n: string;
  title: string;
  heading: string;
  body: string;
  msgs: ChatMessage[];
};

export const STEPS: Step[] = [
  {
    n: "01",
    title: "Connect",
    heading: "Connect your Telegram in 60 seconds.",
    body: 'Message @sidestack_bot once, tap "Connect Account," enter your 2FA. Sidestack indexes your contacts and spins up your dedicated Firecracker microVM. Activated chats live on your VM\'s volume — never in our shared database.',
    msgs: [
      { from: "user", text: "connect my telegram" },
      {
        from: "bot",
        text: "Tap to connect Telegram → 2FA verified ✓\n\nIndexed 412 contacts. Spinning up your private container.",
      },
    ],
  },
  {
    n: "02",
    title: "Tell it what to watch",
    heading: "Tell it what matters. In English.",
    body: 'Set up watchlists in your own words. "DM me every hour if Marco goes silent." "Brief me 20 minutes before any call." Sidestack figures out the rest.',
    msgs: [
      { from: "user", text: "brief me 20 min before any call" },
      {
        from: "bot",
        text: "Done. Watching your calendar. Each brief: last 5 msgs + 1-line context.",
      },
    ],
  },
  {
    n: "03",
    title: "Let it run",
    heading: "It runs. You close.",
    body: "Sidestack monitors your chats, surfaces dying deals, drafts follow-ups, syncs context to your team. Every action is logged. Every action is yours to confirm.",
    msgs: [
      {
        from: "bot",
        text: "☀️ Morning brief\n\n3 deals need you today.\n2 follow-ups drafted.\n1 call at 4pm — brief in 3:40.",
      },
    ],
  },
];
